import { render, staticRenderFns } from "./LocationPlugin.vue?vue&type=template&id=a98c974c&scoped=true"
import script from "./LocationPlugin.vue?vue&type=script&lang=ts"
export * from "./LocationPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./LocationPlugin.vue?vue&type=style&index=0&id=a98c974c&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a98c974c",
  null
  ,true
)

export default component.exports